import React from 'react';
import { Overlay } from './SystemError.styles';
import { LinkUnderlined } from 'lib/common/text';
import { TechnicalMessage } from 'lib/components/TechnicalMessage/TechnicalMessage.view';
import { SUPPORT_EMAIL, SUPPORT_EMAIL_LINK } from 'common/constants';

export const SystemErrorView = ({ modelError }) => {
    const errorText = modelError.toString();

    let message = 'Error fetching data from server.';
    const isPermissionError = modelError.response && modelError.response.status === 403;

    if (isPermissionError) {
        message = (
            <span>
                No permission to access resource. Try <LinkUnderlined href="/logout">login</LinkUnderlined> again.
            </span>
        );
    }

    return (
        <Overlay>
            <TechnicalMessage isError title={errorText}>
                {message} If this error persists please contact{' '}
                <LinkUnderlined href={SUPPORT_EMAIL_LINK}>{SUPPORT_EMAIL}</LinkUnderlined>
            </TechnicalMessage>
        </Overlay>
    );
};
